import {
    FETCH_OVERVIEW_CHART_PENDING,
    FETCH_OVERVIEW_CHART_SUCCESS,
    FETCH_OVERVIEW_CHART_ERROR,
    FETCH_S3_CHART_PENDING,
    FETCH_S3_CHART_SUCCESS,
    FETCH_S3_CHART_ERROR,
    FETCH_BUCKET_COST_CHART_PENDING,
    FETCH_BUCKET_COST_CHART_SUCCESS,
    FETCH_BUCKET_COST_CHART_ERROR,
    FETCH_EC2_CHART_PENDING,
    FETCH_EC2_CHART_SUCCESS,
    FETCH_EC2_CHART_ERROR,
    FETCH_DATA_TRANSFER_CHART_PENDING,
    FETCH_DATA_TRANSFER_CHART_SUCCESS,
    FETCH_DATA_TRANSFER_CHART_ERROR,
    FETCH_RDS_CHART_PENDING,
    FETCH_RDS_CHART_SUCCESS,
    FETCH_RDS_CHART_ERROR,
    FETCH_DATABASE_COST_CHART_PENDING,
    FETCH_DATABASE_COST_CHART_SUCCESS,
    FETCH_DATABASE_COST_CHART_ERROR,
    FETCH_CLOUD_WATCH_CHART_PENDING,
    FETCH_CLOUD_WATCH_CHART_SUCCESS,
    FETCH_CLOUD_WATCH_CHART_ERROR,
    FETCH_EFS_CHART_PENDING,
    FETCH_EFS_CHART_SUCCESS,
    FETCH_EFS_CHART_ERROR,
    FETCH_EFS_USAGE_PENDING,
    FETCH_EFS_USAGE_SUCCESS,
    FETCH_EFS_USAGE_ERROR,
    FETCH_DIRECT_CONNECT_CHART_PENDING,
    FETCH_DIRECT_CONNECT_CHART_SUCCESS,
    FETCH_DIRECT_CONNECT_CHART_ERROR,
    FETCH_SUPPORT_CHART_PENDING,
    FETCH_SUPPORT_CHART_SUCCESS,
    FETCH_SUPPORT_CHART_ERROR,
    FETCH_ROUTE53_CHART_PENDING,
    FETCH_ROUTE53_CHART_SUCCESS,
    FETCH_ROUTE53_CHART_ERROR,
    FETCH_INVOICE_DOWNLOAD_PENDING,
    FETCH_INVOICE_DOWNLOAD_SUCCESS,
    FETCH_INVOICE_DOWNLOAD_ERROR,
    FETCH_SERVICES_HISTORY_PENDING,
    FETCH_SERVICES_HISTORY_SUCCESS,
    FETCH_SERVICES_HISTORY_ERROR,
    CHANGE_CLOUD_ACCOUNT,
    BUCKET_COST_CHANGE_BUCKET,
    BUCKET_COST_CHANGE_USAGE_TYPE,
    BUCKET_COST_CLEAR_FILTER,
    DATABASE_COST_CHANGE_DATABASE,
    DATABASE_COST_CHANGE_USAGE_TYPE,
    DATABASE_COST_CLEAR_FILTER,
} from '../actions/analytics-actions'

const initialState = {
    selectedAccount: null,
    error: null,
    loading: false,
    selectedAccountId: null,
    productsTotalCost: [],
    chartsData: {
        overviewLoading: false,
        overviewChartData: [],
        s3Loading: false,
        s3ChartData: [],
        ec2Loading: false,
        ec2ChartData: [],
        dataTransferLoading: false,
        dataTransferChartData: [],
        rdsLoading: false,
        rdsChartData: [],
        cloudWatchLoading: false,
        cloudWatchChartData: [],
        efsLoading: false,
        efsChartData: [],
        efsUsageLoading: false,
        efsUsageData: [],
        directConnectLoading: false,
        directConnectChartData: [],
        supportLoading: false,
        supportChartData: [],
        route53Loading: false,
        route53ChartData: [],
        downloadInvoice: {
            loading: false,
            billingBucketData: [],
        },
        bucketCostLoading: false,
        bucketCostData: {
            bucketCosts: [],
            selectedBucket: null,
            selectedUsageType: null,
            bucketChartData: [],
            usageTypeChartData: [],
            operationChartData: [],
        },
        databaseCostLoading: false,
        databaseCostData: {
            databaseCosts: [],
            selectedDatabase: null,
            selectedUsageType: null,
            databaseChartData: [],
            usageTypeChartData: [],
            operationChartData: [],
        },
    },
    servicesData: {
        selectedService: null,
        loading: false,
        transfers: [],
    },
}

export default function analytics(state = initialState, action = {}) {
    switch (action.type) {
        case FETCH_OVERVIEW_CHART_PENDING:
            state.chartsData.overviewLoading = true
            return { ...state, chartsData: state.chartsData }

        case FETCH_OVERVIEW_CHART_SUCCESS: {
            const overviewData = []
            const productsCostList = []

            action.data.map(productCost => {
                overviewData.push([
                    productCost.product_name,
                    productCost.total_cost,
                ])
                productCost.total_cost > 0 && productsCostList.push(productCost)
            })
            state.chartsData.overviewChartData = overviewData
            state.chartsData.overviewLoading = false
            return {
                ...state,
                chartsData: state.chartsData,
                productsTotalCost: productsCostList,
                loading: false,
            }
        }

        case FETCH_OVERVIEW_CHART_ERROR:
            state.chartsData.overviewChartData = []
            state.chartsData.overviewLoading = false
            return {
                ...state,
                chartsData: state.chartsData,
                productsTotalCost: [],
                error: action.message,
                loading: false,
            }

        case FETCH_SERVICES_HISTORY_PENDING:
            state.servicesData.loading = true
            return { ...state }

        case FETCH_SERVICES_HISTORY_SUCCESS: {
            const transfersData = []

            action.data.transfers.map(transfer => {
                transfersData.push(transfer)
            })
            state.servicesData.transfers = transfersData
            state.servicesData.loading = false
            return { ...state, servicesData: state.servicesData }
        }

        case FETCH_SERVICES_HISTORY_ERROR:
            state.servicesData.transfers = []
            state.servicesData.loading = false
            return { ...state, servicesData: state.servicesData }

        case FETCH_S3_CHART_PENDING:
            state.chartsData.s3Loading = true
            return { ...state, chartsData: state.chartsData }

        case FETCH_S3_CHART_SUCCESS: {
            state.chartsData.s3Loading = false
            const s3Data = []
            action.data.map(s3 => {
                s3Data.push([s3.usage_type, s3.total_cost])
            })
            state.chartsData.s3ChartData = s3Data
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_S3_CHART_ERROR:
            state.chartsData.s3Loading = true
            state.chartsData.s3ChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_BUCKET_COST_CHART_PENDING:
            state.chartsData.bucketCostLoading = true
            return { ...state }

        case FETCH_BUCKET_COST_CHART_SUCCESS: {
            state.chartsData.bucketCostLoading = false
            const bucketCostData = []
            const bucketChartData = []
            action.data.map(bucketCost => {
                bucketCostData.push(bucketCost)
                bucketChartData.push([
                    bucketCost.bucket_name,
                    bucketCost.total_cost,
                ])
            })
            state.chartsData.bucketCostData.bucketChartData = bucketChartData
            state.chartsData.bucketCostData.bucketCosts = bucketCostData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_BUCKET_COST_CHART_ERROR:
            state.chartsData.bucketCostData.bucketChartData = []
            state.chartsData.bucketCostData.bucketCosts = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_EC2_CHART_PENDING:
            state.chartsData.ec2Loading = true
            return { ...state }

        case FETCH_EC2_CHART_SUCCESS: {
            state.chartsData.ec2Loading = false
            const ec2Data = []
            action.data.map(ec2 => {
                ec2Data.push([ec2.usage_type, ec2.total_cost])
            })
            state.chartsData.ec2ChartData = ec2Data
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_EC2_CHART_ERROR:
            state.chartsData.ec2Loading = false
            state.chartsData.ec2ChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_DATA_TRANSFER_CHART_PENDING:
            state.chartsData.dataTransferLoading = true
            return { ...state }

        case FETCH_DATA_TRANSFER_CHART_SUCCESS: {
            state.chartsData.dataTransferLoading = false
            const dataTransferData = []
            action.data.map(dt => {
                dataTransferData.push([dt.usage_type, dt.total_cost])
            })
            state.chartsData.dataTransferChartData = dataTransferData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_DATA_TRANSFER_CHART_ERROR:
            state.chartsData.dataTransferLoading = false
            state.chartsData.dataTransferChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_RDS_CHART_PENDING:
            state.chartsData.rdsLoading = true
            return { ...state }

        case FETCH_RDS_CHART_SUCCESS: {
            state.chartsData.rdsLoading = false
            const rdsData = []
            action.data.map(rds => {
                rdsData.push([rds.usage_type, rds.total_cost])
            })
            state.chartsData.rdsChartData = rdsData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_RDS_CHART_ERROR:
            state.chartsData.rdsLoading = false
            state.chartsData.rdsChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_DATABASE_COST_CHART_PENDING:
            state.chartsData.databaseCostLoading = true
            return { ...state }

        case FETCH_DATABASE_COST_CHART_SUCCESS: {
            state.chartsData.databaseCostLoading = false
            const databaseCostData = []
            const databaseChartData = []
            action.data.map(databaseCost => {
                if (databaseCost.database_name != '') {
                    databaseCostData.push(databaseCost)
                    databaseChartData.push([
                        databaseCost.database_name,
                        databaseCost.total_cost,
                    ])
                }
            })
            state.chartsData.databaseCostData.databaseChartData = databaseChartData
            state.chartsData.databaseCostData.databaseCosts = databaseCostData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_DATABASE_COST_CHART_ERROR:
            state.chartsData.databaseCostData.databaseChartData = []
            state.chartsData.databaseCostData.databaseCosts = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_CLOUD_WATCH_CHART_PENDING:
            state.chartsData.cloudWatchLoading = true
            return { ...state }

        case FETCH_CLOUD_WATCH_CHART_SUCCESS: {
            state.chartsData.cloudWatchLoading = false
            const cloudWatchData = []
            action.data.map(cw => {
                cloudWatchData.push([cw.usage_type, cw.total_cost])
            })
            state.chartsData.cloudWatchChartData = cloudWatchData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_CLOUD_WATCH_CHART_ERROR:
            state.chartsData.cloudWatchLoading = false
            state.chartsData.cloudWatchChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_EFS_CHART_PENDING:
            state.chartsData.efsLoading = true
            return { ...state }

        case FETCH_EFS_CHART_SUCCESS: {
            state.chartsData.efsLoading = false
            const efsData = []
            action.data.map(efs => {
                efsData.push([efs.usage_type, efs.total_cost])
            })
            state.chartsData.efsChartData = efsData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_EFS_CHART_ERROR:
            state.chartsData.efsLoading = false
            state.chartsData.efsChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_EFS_USAGE_PENDING:
            state.chartsData.efsUsageLoading = true
            return { ...state }

        case FETCH_EFS_USAGE_SUCCESS: {
            state.chartsData.efsUsageLoading = false
            const efsUsageData = []
            if (!action.data) action.data = []

            action.data.map(efs => {
                efsUsageData.push(efs)
            })
            state.chartsData.efsUsageData = efsUsageData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_EFS_USAGE_ERROR:
            state.chartsData.efsUsageLoading = false
            state.chartsData.efsUsageData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_DIRECT_CONNECT_CHART_PENDING:
            state.chartsData.directConnectLoading = true
            return { ...state }

        case FETCH_DIRECT_CONNECT_CHART_SUCCESS: {
            state.chartsData.directConnectLoading = false
            const dcData = []
            action.data.map(dc => {
                dcData.push([dc.usage_type, dc.total_cost])
            })
            state.chartsData.directConnectChartData = dcData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_DIRECT_CONNECT_CHART_ERROR:
            state.chartsData.directConnectLoading = false
            state.chartsData.directConnectChartData = []
            return {
                ...state,
                loading: false,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_SUPPORT_CHART_PENDING:
            state.chartsData.supportLoading = true
            return { ...state }

        case FETCH_SUPPORT_CHART_SUCCESS: {
            state.chartsData.supportLoading = false
            const supportData = []
            action.data.map(support => {
                supportData.push([support.usage_type, support.total_cost])
            })
            state.chartsData.supportChartData = supportData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_SUPPORT_CHART_ERROR:
            state.chartsData.supportLoading = false
            state.chartsData.supportChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_ROUTE53_CHART_PENDING:
            state.chartsData.route53Loading = true
            return { ...state }

        case FETCH_ROUTE53_CHART_SUCCESS: {
            state.chartsData.route53Loading = false
            const routeData = []
            action.data.map(r => {
                routeData.push([r.usage_type, r.total_cost])
            })
            state.chartsData.route53ChartData = routeData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_ROUTE53_CHART_ERROR:
            state.chartsData.route53Loading = false
            state.chartsData.route53ChartData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case FETCH_INVOICE_DOWNLOAD_PENDING:
            state.chartsData.downloadInvoice.loading = true
            return { ...state }

        case FETCH_INVOICE_DOWNLOAD_SUCCESS: {
            state.chartsData.downloadInvoice.loading = false
            const downloadData = []
            action.data.items.map(r => {
                downloadData.push(r)
            })
            state.chartsData.downloadInvoice.billingBucketData = downloadData
            return { ...state, chartsData: state.chartsData }
        }

        case FETCH_INVOICE_DOWNLOAD_ERROR:
            state.chartsData.downloadInvoice.loading = false
            state.chartsData.downloadInvoice.billingBucketData = []
            return {
                ...state,
                chartsData: state.chartsData,
                error: action.message,
            }

        case CHANGE_CLOUD_ACCOUNT:
            return { ...state, selectedAccount: action.data }

        case BUCKET_COST_CHANGE_BUCKET:
            state.chartsData.bucketCostData.selectedBucket =
                action.data.selectedBucket
            state.chartsData.bucketCostData.usageTypeChartData =
                action.data.usageTypeChartData
            state.chartsData.bucketCostData.selectedUsageType = null
            return { ...state, chartsData: state.chartsData }

        case BUCKET_COST_CHANGE_USAGE_TYPE:
            state.chartsData.bucketCostData.selectedUsageType =
                action.data.selectedUsageType
            state.chartsData.bucketCostData.operationChartData =
                action.data.operationChartData
            return { ...state, chartsData: state.chartsData }

        case BUCKET_COST_CLEAR_FILTER:
            state.chartsData.bucketCostData.selectedBucket = null
            state.chartsData.bucketCostData.selectedUsageType = null
            return { ...state, chartsData: state.chartsData }

        case DATABASE_COST_CHANGE_DATABASE:
            state.chartsData.databaseCostData.selectedDatabase =
                action.data.selectedDatabase
            state.chartsData.databaseCostData.usageTypeChartData =
                action.data.usageTypeChartData
            state.chartsData.databaseCostData.selectedUsageType = null
            return { ...state, chartsData: state.chartsData }

        case DATABASE_COST_CHANGE_USAGE_TYPE:
            state.chartsData.databaseCostData.selectedUsageType =
                action.data.selectedUsageType
            state.chartsData.databaseCostData.operationChartData =
                action.data.operationChartData
            return { ...state, chartsData: state.chartsData }

        case DATABASE_COST_CLEAR_FILTER:
            state.chartsData.databaseCostData.selectedDatabase = null
            state.chartsData.databaseCostData.selectedUsageType = null
            return { ...state, chartsData: state.chartsData }

        default:
            return state
    }
}
